import React, { createContext } from "react";
import data from "static/data";

const dataObj = data.data;

/**
 * initial state
 */
export const DataContext = createContext({
  data: {},
  products: {},
  translations: {},
  resetContext: () => {},
  updateData: () => {},
});

/**
 * Provider
 */

export class DataProvider extends React.Component {
  state = {
    steps: dataObj[this.props.lang].steps,
    products: dataObj[this.props.lang].products,
    translations: dataObj[this.props.lang].translations,
    updateData: value => this.updateData(value),
    resetContext: () => this.resetContext(),
  };

  resetContext = () => {
    this.setState({
      steps: dataObj[this.props.lang].steps,
      products: dataObj[this.props.lang].products,
      translations: dataObj[this.props.lang].translations,
    });
  };

  updateData = async newValue => {
    this.setState({ data: newValue });
  };

  render() {
    return <DataContext.Provider value={this.state}>{this.props.children}</DataContext.Provider>;
  }
}

/**
 * consumer
 */

export const DataConsumer = DataContext.Consumer;

/*
  import { DataProvider } from 'context/dataContext'
  import { DataContext } from 'context/dataContext'
  <DataProvider>
    provider
  </DataProvider>
  */
